// extracted by mini-css-extract-plugin
export default {"input":"LoginForm_input__-BYXv","button":"LoginForm_button__0QH16","error":"LoginForm_error__6cNX3"};